module.exports = __webpack_public_path__ + "img/infoSvgIconSmall.4f4eb279.svg";